import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Tooltip,
  Button,
  InputAdornment,
  Typography
} from "@mui/material";

import { Controller, useForm } from "react-hook-form";
import ReusableModal from "../../Components/Modal/WSModal";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import { resetDataComponent } from "../../StateManagement/actions";
// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import { useDispatch } from "react-redux";

interface EstimateModalProps {
  id: string;
  open: boolean;
  onClose: () => void;
  onCreate: (data: any) => void;
}

const EstimateModal: React.FC<EstimateModalProps> = ({
  id,
  open,
  onClose,
  onCreate
}) => {
  const { control, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  // const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [recurrence, setRecurrence] = useState("None");
  const [showNewClientField, setShowNewClientField] = useState<boolean>(false);
  const [selectedRateCardRoles, setSelectedRateCardRoles] = useState([]);
  const [formQuantities, setFormQuantities] = useState<any>({});

  useEffect(() => {
    const fetchDataById = async () => {
      setLoading(true);
      try {
        const response: any = await callAPI(
          "estimates/getBy",
          Method.GET,
          {},
          id
        );

        const data = response?.estimate;
        const client = data?.client;

        if (data && client) {
          setValue("client", client._id);
          setValue("email", client.email);
          setValue("phone", client.phone);
          setValue("address", client.address);
          setValue("note", client.note);
          setValue("rateCard", client.rateCard);
          setValue("company", client.company);

          setValue("title", data.title);
          setValue("template", data.template);
          setValue("estimationPoints", data.estimationPoints);
          setValue("recurrence", data.recurrence);
          setValue("duration", data.duration);
          setValue("totalCalculationFormat", data.totalCalculationFormat);
          setValue("total", data.total);
          setValue("description", data.description);
          setValue("status", data.status);
        }
      } catch (error: any) {
        if (error.message === 'GlobalHandledError') return;
        showMessage(
          error.response?.data?.message || "Failed to retrieve account data",
          "error"
        );
        console.error("Failed to retrieve account data", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchDataById();
  }, [id, setValue]);

  const handleTransformData = (data: any) => {
    let allData: Array<any> = [];

    data.map((value: any) => {
      allData.push({ label: value.name, value: value._id });
    });

    return allData;
  };

  const clientSource = {
    url: "clients/search",
    pageSize: 100000,
    page: 1,
    filter: [],
    sort: []
  };

  const rateCardSource = {
    url: "rateCards/search",
    pageSize: 100000,
    page: 1,
    filter: [],
    sort: []
  };

  const options = [
    { label: "None", value: "None" },
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
    { label: "Quarterly", value: "Quarterly" },
    { label: "Yearly", value: "Yearly" }
  ];

  const formats = [
    { label: "Rounded", value: "rounded" },
    { label: "Exact", value: "exact" }
  ];

  const template = [
    { label: "None (Blank Estimate)", value: "None (Blank Estimate)" }
  ];

  const points = [
    { label: "Three (Low, Most Likely, High)", value: "three" },
    { label: "Two (Low, High)", value: "two" },
    { label: "One (Most Simple)", value: "one" }
  ];

  const handleRateCardChange = async (rateCardId: string) => {
    try {
      const response: any = await callAPI(
        `rateCards/getBy`,
        Method.GET,
        {},
        rateCardId
      );
      const roles = response.rateCard.roles;
      setSelectedRateCardRoles(roles);

      // Optional: prefill quantity state
      const initialQuantities: any = {};
      roles.forEach((role: any) => {
        initialQuantities[role._id] = 0;
      });
      setFormQuantities(initialQuantities);
    } catch (err) {
      console.error("Failed to fetch rate card roles", err);
    }
  };

  const onSubmit = async (data: any) => {
    onCreate(data);
    reset();
  };

  const footer = (
    <Button
      variant="contained"
      onClick={handleSubmit(onSubmit)}
      sx={{
        backgroundColor: "#FF6B2C",
        "&:hover": { backgroundColor: "#e65c1d" }
      }}
    >
      Create
    </Button>
  );

  return (
    <ReusableModal
      open={open}
      onClose={onClose}
      title="New Estimate"
      footer={footer}
      width="sm"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSTextField
            id="title"
            label="Estimate Title"
            name="title"
            control={control}
            rules={{ required: "Estimate title is required" }}
            sx={{
              marginBottom: 1,
              backgroundColor: "rgba(0,0,0,.05)",
              boxShadow: "none",
              border: 0,
              color: "#444",
              fontSize: 16,
              transition: "width 0.25s"
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSSelectField
            id="client"
            label={"Select Client"}
            name="client"
            control={control}
            source={clientSource}
            rules={{ required: !showNewClientField  ? "please select a client" :  false }}
            transFormData={handleTransformData}
            disabled={showNewClientField}
          />
        </Grid>

        {/* {!id && (
          <>
            {!showNewClientField ? (
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  sx={{ color: "#FF6B2C", cursor: "pointer" }}
                  onClick={() => setShowNewClientField(true)}
                >
                  ➕ Want to add a new client?
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  sx={{ color: "#FF6B2C", cursor: "pointer" }}
                  onClick={() => setShowNewClientField(false)}
                >
                  Continue with existing client?
                </Typography>
              </Grid>
            )}

            {showNewClientField && (
              <Grid item xs={12}>
                <WSTextField
                  id="clientName"
                  label="New Client Name"
                  name="newClientName"
                  control={control}
                  rules={{ required: "New client name is required" }}
                  sx={{
                    marginBottom: 1,
                    backgroundColor: "rgba(0,0,0,.05)",
                    boxShadow: "none",
                    border: 0,
                    color: "#444",
                    fontSize: 16,
                    transition: "width 0.25s"
                  }}
                />
              </Grid>
            )}
          </>
        )} */}

        <Grid item xs={12}>
          <WSSelectField
            id="template"
            label={"Select Template"}
            name="template"
            control={control}
            options={template}
            rules={{ required: "please select a template" }}
          />
        </Grid>
        <Grid item xs={12}>
          <WSSelectField
            id="estimationPoints"
            label={"Estimation Points"}
            name="estimationPoints"
            control={control}
            options={points}
            rules={{ required: "please enter estimate points" }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSSelectField
            id="rateCardId"
            label={"Select Rate Card"}
            name="rateCard"
            control={control}
            source={rateCardSource}
            rules={{ required: "please select a rate card" }}
            transFormData={handleTransformData}
            onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
              handleRateCardChange(e.target.value as string)
            }
          />
        </Grid>

        {/* {selectedRateCardRoles.length > 0 && (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Role-Based Quantity
            </Typography>
          </Grid>
        )} */}

        {/* {selectedRateCardRoles.map((role: any) => (
          <Grid item xs={12} key={role._id}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={4}>
                <Typography variant="body1" fontWeight="500">
                  {role.role}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <WSTextField
                  id="rate"
                  label="Rate"
                  name="rate"
                  defaultValue={role.customerRate.toLocaleString()}
                  type={TextType.Currency}
                  currency={CurrencyType.Rupee}
                  size="small"
                  control={control}
                  disabled
                />
              </Grid>
              <Grid item xs={4}>
                <WSTextField
                  id="qty"
                  label="Qty"
                  name="quantity"
                  type={TextType.AllowOnlyNumber}
                  size="small"
                  control={control}
                  onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
                    setFormQuantities({
                      ...formQuantities,
                      [role._id]: e.target.value as string
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        ))} */}

        {/* Recurring Pricing Calculation */}
        <Grid item xs={12}>
          <WSSelectField
            id="recurrence"
            label={"Recurring Pricing Calculation"}
            name="recurrence"
            control={control}
            rules={{ required: "please select a price calculation" }}
            onChange={(e: React.ChangeEvent<{ value: unknown }>) =>
              setRecurrence(e.target.value as string)
            }
            options={options}
          />
        </Grid>
        {/* Estimated Project Duration */}
        {recurrence !== "None" && (
          <Grid item xs={12}>
            <Controller
              name="duration"
              control={control}
              defaultValue=""
              rules={{
                required: "Duration is required when recurrence is set",
                min: { value: 1, message: "Duration must be at least 1" }
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  type="number"
                  fullWidth
                  label="Estimated Project Duration"
                  error={!!error}
                  helperText={error?.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {recurrence === "Weekly"
                          ? "Week"
                          : recurrence === "Monthly"
                          ? "Month"
                          : recurrence === "Quarterly"
                          ? "Quarter"
                          : recurrence === "Yearly"
                          ? "Year"
                          : ""}
                      </InputAdornment>
                    )
                  }}
                />
              )}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <WSSelectField
            id="totalCalculationFormat"
            label={"Total Calculation Format"}
            name="totalCalculationFormat"
            control={control}
            rules={{ required: "please select calculation format" }}
            options={formats}
          />
        </Grid>
        <Grid item xs={12}>
          <WSTextAreaField
            id="description"
            label="Description (optional)"
            name="description"
            control={control}
          />
        </Grid>
      </Grid>
    </ReusableModal>
  );
};

export default EstimateModal;
